<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
    @click:outside="closeDialog()"
    @keydown="closeDialog()"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <slot name="body" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          :disabled="loading"
          @click="closeDialog()"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          :loading="loading"
          :disabled="loading"
          @click="$emit('deleteTriggered')"
        >
          Deletar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: false
    }
  },

  watch: {
    showDialog(newValue) {
      this.dialog = newValue;
    }
  },

  methods: {
    closeDialog() {
      if (this.loading) {
        return;
      }

      this.$emit('changeValue', false);
    }
  }
}
</script>
